import {Component} from "react";
import AppMainIcon from "../../media/app-images/AppMainIcon.mjs";
import "./AppMainBackground.css";

const prefix="AppMainBackground";

const AppMainBackground = class extends Component {
	render() {
		return (
			<div className={prefix}>
				<AppMainIcon />
			</div>
		)
	}
}

export default AppMainBackground;